// extracted by mini-css-extract-plugin
export default {"container":"SearchCatalogHeader-module__container--aBLih"};